import { useSelector, useDispatch } from 'react-redux'

import React, { useState, useEffect } from 'react'

import { runActionHandler } from '../../redux/notifications/actions'

function truncateString(str, num) {
  if (str.length <= num) {
    return str
  }
  return str.slice(0, num) + '...'
}



const Notifications = ( props ) => {

  const dispatch = useDispatch()

  const notifications= useSelector( state => state.notifications.notifications )

  if ( !notifications.length ) return null

  const Notification = (props) => {
    const notification = props.notification

    const action = () => {
      dispatch(runActionHandler( notification ) )
    }

    return (
      <div className="Notification" onClick = { action }>
        <div className="icon">
          <img src={ notification.icon }></img>
        </div>
        <div className="details">
          <div className="from">
            { notification.fromName }
          </div>
          <div className="message">
            { truncateString(notification.message,100) }
          </div>
        </div>

      </div>
    )
  }

  var notificationsList = []

  notifications.forEach ( ( notification ) => {
    console.log(notification)
    notificationsList.push((
      <>
        <Notification notification = { notification }></Notification>
      </>
    ))
  } )

  return (
    <div className="Notifications">
      { notificationsList }
    </div>
  )
}

export default Notifications